import { PureComponent } from 'react';
import { func } from 'prop-types';
import classnames from 'classnames';
import { animateScroll } from 'react-scroll';
import { ArrowUpOutlined } from 'jl-design-system/components/icons/ArrowUpOutlined';
import { throttle } from '~/utils';
import styles from './BackToTopIcon.scss';

const backToTopThreshold = 170 * 5;

export class BackToTopIcon extends PureComponent {
  state = {
    scroll: 0,
    active: false,
    position: '8px',
  };

  componentDidMount() {
    window.addEventListener('scroll', this.setScrollPosition);
  }

  componentDidUpdate(prevProps, prevState) {
    const { scroll } = this.state;

    if (scroll !== prevState.scroll) {
      this.changeActiveState(scroll >= backToTopThreshold);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.setScrollPosition);
  }

  setScrollPosition = throttle(() => {
    const { position } = this.props;
    this.setState(() => ({
      scroll: window.pageYOffset,
      position: `${position()}px`,
    }));
  }, 100);

  changeActiveState = (active) => {
    this.setState(() => ({
      active,
    }));
  };

  onClick = () => {
    animateScroll.scrollToTop();
  };

  render() {
    const { active, position } = this.state;

    return (
      <button
        className={classnames(styles.BackToTopIcon, {
          [styles.BackToTopIcon_active]: active,
        })}
        style={{ right: position }}
        type="button"
        onClick={this.onClick}
      >
        <ArrowUpOutlined title="Back to Top" size="large" />
      </button>
    );
  }
}

BackToTopIcon.propTypes = {
  position: func.isRequired,
};
